export const authState = {
    isLoggedIn: false,
    authDetails: {},
    alert: {
        open: false,
        message: '',
        severity: 'success'
    }
}